import { useTranslation } from '@/i18n';
import { cx } from '@/lib/cx';
import { EventsView } from './EventsView';
import { MessagesView } from './MessagesView';
import { SourcesView } from './SourcesView';
import { MONITOR_VIEWS, useMonitorParams } from './useMonitorParams';
import styles from './MonitorPage.module.css';

/**
 * The integration monitor. ADMIN only — every call behind it answers 403 for any
 * other role.
 *
 * Three views of one system, in the order questions get asked: **Sources** — is
 * every feed alive? — is the landing view and the traffic lights. **Events** — what
 * did a feed do, and why is one red? **Deliveries** — what exactly arrived, payload
 * included. The view lives in the URL like every filter, so "look at this source's
 * errors" is a link.
 */
export const MonitorPage = () => {
  const { params, update } = useMonitorParams();
  const { t } = useTranslation();

  return (
    <div className={styles.page}>
      <div className={styles.toolbar}>
        <h1 className={styles.title}>{t('monitor.title')}</h1>

        <nav className={styles.tabs} aria-label={t('monitor.title')}>
          {MONITOR_VIEWS.map((view) => (
            <button
              key={view}
              type="button"
              className={cx(styles.tab, params.view === view && styles.tabActive)}
              aria-current={params.view === view ? 'page' : undefined}
              onClick={() => update({ view })}
            >
              {t(`monitor.views.${view}`)}
            </button>
          ))}
        </nav>
      </div>

      {params.view === 'sources' && <SourcesView />}
      {params.view === 'events' && <EventsView />}
      {params.view === 'messages' && <MessagesView />}
    </div>
  );
};
